import(/* webpackMode: "eager" */ "/home/runner/work/psx-frontend/psx-frontend/app/indices/[index]/page.tsx");
